module.exports = __webpack_public_path__ + "static/img/6.c84173b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/eng/6.png
// module id = IRUx
// module chunks = 0